import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {GetInstanceInfo as GetInstanceInfoQuery} from 'nutshell-graphql-types';

import GET_INSTANCE_INFO from './graphql/queries/get-instance-info.graphql';

export const useInstanceInfo = () => {
    const {
        loading: isLoading,
        data,
        error,
    } = useQuery<GetInstanceInfoQuery, Record<any, any>>(GET_INSTANCE_INFO, {
        fetchPolicy: 'cache-and-network',
    });

    const instance = data ? data.sessionInstance : null;

    return {
        isLoading,
        instance: instance,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
    };
};
